<nav class="navbar navbar-light bg-light navbar-expand-lg ">
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <div class="form-inline me-2">
        <input id="busquedaFormControl" type="text" class="form-control" placeholder="Buscador"
          [formControl]="buscadorFormControl" (input)="filtrarAsignacionPorTextoBusqueda()"/>
    </div>
    <ul class="navbar-nav me-auto">    
      <li class="nav-item float-end me-2">
        <button type="button" class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2" [disabled]="authService.hasRole(TipoUsuario.SOPORTE)" (click)="crearNuevoGrupo()"> Agregar</button>
      </li>
    </ul>
  </div>
</nav>

<div class="row">  
  <div class="col col-3">
    <div class="list-group py-3 menu-izq">
      <div class="col col-md-12" *ngIf="loading">
          <div class="spinner-container" >
            <ngx-spinner name="spinnerLista" bdOpacity=0.3bd
              Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
              <p style="color: white">C a r g a n d o . . . </p>
            </ngx-spinner>
          </div>
        </div>
        <div *ngIf="!loading">
          <div *ngFor="let a of listaAsignacionesFiltradas; let i=index">
            <button type="button" class="list-group-item list-group-item-action" (click)="usuarioSeleccionoAsignacion(a)">
              <div class="d-flex w-100 justify-content-between">
                <p >{{ a.nombreAsignacion }} </p>
              </div>
            </button>
          </div>
        </div>        
    </div>
  </div>
  <div class="col col-9 py-3">
    <div *ngIf="asignacionSeleccionada !== null" id="tablaInformacion">
      <app-asignar-aeroplantas-detalle [asignacionSeleccionada] = "asignacionSeleccionada"></app-asignar-aeroplantas-detalle>
    </div>
  </div>
</div>
  
  <ng-template #content let-modal>
      <app-asignar-aeroplantas-detalle></app-asignar-aeroplantas-detalle>
  </ng-template>
